import mainLogo from "../../assets/images/logo.svg";
import discordIcon from "../../assets/images/discordIcon.svg";
import "./footer.css";
import TwitterIcon from '@material-ui/icons/Twitter';

const Footer = () => {
    return (
        <footer className="web-footer">
            <div className="container">
                <div className="row">
                    <div className="col-7">
                    <img className="footer-logo" src={mainLogo} alt="G-Fox" />

                    </div>
                    <div className="col-5">
                    <div className="f-logos ml-auto">
                        <a className="twitter" href="/" target="_blank"><TwitterIcon/></a>
                        <a className="discord" href="/" target="_blank"><img src={discordIcon} alt="discord" /></a>
                    </div>
                    </div>
                   
                </div>
            </div>
        <div className="d-flex align-items-center justify-content text-center py-3 text-white cs-border">
            <p className="text-center my-0 mx-auto ">Design & Developed by <a target="_blank" rel="noopener noreferrer" href="https://smashcode.dev/" className="primary-anchor"> Smash Code</a></p>
        </div>
        </footer>
    )
}

export default Footer
